export const currencyType = (symbol, isForGA4Event) => {
  if (!symbol) return "";
  const value = symbol.toLowerCase();
  let data = null;
  switch (value) {
    case "eur":
      data = "EUR";
      break;
    case "usd":
      data = "USD";
      break;
    case "gbp":
      data = "GBP";
      break;
    case "tl":
      data = isForGA4Event ? "TRY" : "TL";
      break;
    case "£":
      data = "GBP";
      break;
    case "$":
      data = "USD";
      break;
    case "€":
      data = "EUR";
      break;
    default:
      data = "";
      break;
  }
  return data;
};
